import { useQuery } from "react-query";
import { GetTimeseriesRequest } from "../types/timeseries";
import useQueryState from "./useQueryState";
import { getDroughtEventsTimeseriesService } from "../services/droughtEvent";

export type UseTimeseries = GetTimeseriesRequest;

const useDroughtEvents = () => {
  const { queryState: {  country, droughtEvents }} = useQueryState()

  const getDroughtEventsTimeseries = useQuery(
    ["droughtEvents", country, droughtEvents],
    async () => await getDroughtEventsTimeseriesService({
        country
    }),
    {
      retry: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled: !!country && !!droughtEvents
    }
  );

  return getDroughtEventsTimeseries;
};

export default useDroughtEvents;
